import { Box } from 'components/Box';
import { I18nTypography } from 'components/typography/i18nTypography';
import { useIsApp } from 'utils/hooks/useGetIsApp';
import { EsBannerContainer } from './betting-warning-banner-container';

/*------------------------------types------------------------------*/

type EsBettingWarningBannerProps = {
  isSticky?: boolean;
};

/*------------------------------component------------------------------*/

function EsBettingWarningBanner({ isSticky }: EsBettingWarningBannerProps) {
  const isApp = useIsApp();

  return (
    <EsBannerContainer isSticky={isSticky} isApp={isApp}>
      <Box>
        <I18nTypography
          as="p"
          margin="0"
          variant="bodyLeadBold"
          id="esWarningBannerTitle"
        />
        <I18nTypography
          variant="bodyMicroCaption"
          fontWeight={700}
          id="esWarningBannerSubtitle"
        />
      </Box>
    </EsBannerContainer>
  );
}

export { EsBettingWarningBanner };
